module.exports = __webpack_public_path__ + "static/media/blog-48.25de3266.webp";